import { Box } from '@mui/system';
import Header from '../../common/header/Header';
import Breadcrumb from '../../common/header/Breadcrumb';
import EditAgent from '../../components/agentListView/EditAgent';
import React,{useEffect} from 'react';

function EditAgents() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <EditAgent />
            </Box>
        </>
    );
}

export default EditAgents;
